/*
yogeshsrigiri 09/29/2022 3075154998 implemented breadcrumbs for all the side menu pages
Akhila  10/28/2022 3075154998 data manager ux changes
Suresh Peddavoora 10/28/2022 3075154998  Added Class Name for header dashboard
ashraf 10/30/2022 3075154998 conditional tabs render
ashraf 12/15/2022 3075154998 renamed tab label
Suresh Peddavoora 12/16/2022 3075154998 Fixed Landing Page Alignments when Sidenav Enabled

*/
import {Card} from '@material-ui/core';
import React from 'react';
import Tabs from './Tabs';
import LandingPage from '../../LandingPage';

function EnableFramework() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabLabels = ['Data Manager', 'Records', 'Record Group', 'Filter', 'Filter Group', 'Matching Logic'];
  return (
    <>
      <LandingPage title={'Data Manager'} showTabs={true} tabValue={value} handleTabChange={handleChange} allAntTabs={tabLabels}>
        <div className={`global-field-dash-board`}>
          <Card className={`mb-0`} elevation={0}>

            <Tabs value={value} setValue={setValue} />

          </Card>
        </div>
      </LandingPage>
    </>
  );
}

export default EnableFramework;
